import { ZAttrMeta } from "src/business/attribute";

import { OptionRecord } from "./OptionRecord";

export const buildOrderRecords = (
  attr: ZAttrMeta,
): OptionRecord[] | undefined => {
  if (
    attr.type.name !== "strOption" ||
    attr.edit?.component?.type !== "Select" ||
    attr.edit.component.options.type !== "inline"
  )
    return undefined;
  const defaultId = attr.type.defaultValue?.id;
  return attr.edit.component.options.list.map(
    ({ id, label }) =>
      ({
        id,
        label,
        order: undefined,
        isDefault: !!defaultId && defaultId === id,
      }) satisfies OptionRecord,
  );
};
